import type {
	CreateTariffInput,
	UpdateTariffInput
} from '@/graphql/generated';

export interface TariffFormValues {
	name: string;
	version: string;
	description: string;
	entryGracePeriodMinutes: number | undefined;
	postPaymentGraceMinutes: number | undefined;
	freeExitMinutes: number | undefined;
	lostTicketFixedCharge: string;
	lostTicketRateId: string;
	reEntryChargeRateId: string;
	sourceTariffId: string;
	status: number;
}

export const buildCreateTariffInput = (
	values: TariffFormValues,
	tariffId: string
): CreateTariffInput => ({
	tariffId,
	name: values.name.trim(),
	version: values.version?.trim() || undefined,
	description: values.description?.trim() || undefined,
	sourceTariffId: values.sourceTariffId || undefined,
	entryGracePeriodMinutes: values.entryGracePeriodMinutes ?? undefined,
	postPaymentGraceMinutes: values.postPaymentGraceMinutes ?? undefined,
	freeExitMinutes: values.freeExitMinutes ?? undefined,
	lostTicketFixedCharge: values.lostTicketFixedCharge
		? Number(values.lostTicketFixedCharge)
		: undefined,
	lostTicketRateId: values.lostTicketRateId || undefined,
	reEntryChargeRateId: values.reEntryChargeRateId || undefined
});

export const buildUpdateTariffInput = (
	values: TariffFormValues,
	tariffId: string
): UpdateTariffInput => ({
	tariffId,
	name: values.name.trim(),
	version: values.version?.trim() || undefined,
	description: values.description?.trim() || undefined,
	entryGracePeriodMinutes: values.entryGracePeriodMinutes ?? undefined,
	postPaymentGraceMinutes: values.postPaymentGraceMinutes ?? undefined,
	freeExitMinutes: values.freeExitMinutes ?? undefined,
	lostTicketFixedCharge: values.lostTicketFixedCharge
		? Number(values.lostTicketFixedCharge)
		: undefined,
	lostTicketRateId: values.lostTicketRateId || undefined,
	reEntryChargeRateId: values.reEntryChargeRateId || undefined,
	status: values.status
});
